import React, { useState, useEffect } from "react";
import api from "../../services/api";
import serverHost from "../../services/serverHost";
import {
  Button,
  createTheme,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ThemeProvider,
} from "@mui/material";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";

let tituloMusica = "";
let playAudio = "";

export default function Musicas({ unidadeId }) {
  const [listaMusicas, setListaMusicas] = useState([]);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    carregarMusicas();
  }, []);

  const carregarMusicas = () => {
    api
      .get("unidades/listarMusicas", { unidadeId })
      .then((res) => {
        setListaMusicas(res);
      })
      .catch((e) => console.log("error", "Erro: " + e));
  };

  const handleClose = () => {
    setPlay(false);
  };

  return (
    <List
      style={{
        padding: "0px 10px 0px 10px",
        borderRight: "2px solid rgb(213, 213, 213)",
        borderBottom: "2px solid rgb(213, 213, 213)",
        borderLeft: "2px solid rgb(213, 213, 213)",
        borderBottomRightRadius: 15,
        borderBottomLeftRadius: 15,
      }}
    >
      <br />
      {listaMusicas.map((musica, index) => (
        <>
          <ListItem
            sx={{
              width: "100%",
              // bgcolor: "#e8e8e8",
              marginBottom: 2,
              borderRadius: "20px",
            }}
          >
            <ListItemText primary={musica.nome} />
            <IconButton
              sx={{ background: "#3D79AD" }}
              onClick={() => {
                setPlay(true);
                tituloMusica = musica.nome;
                playAudio = musica.caminhoArquivo;
              }}
            >
              <PlayArrowIcon sx={{ color: "#FFFF" }} />
            </IconButton>
          </ListItem>
        </>
      ))}
      <Dialog
        onClose={handleClose}
        fullWidth={true}
        open={play}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            style={{ textAlign: "center" }}
            id="alert-dialog-description"
          >
            <h4>{tituloMusica}</h4>
            <br />
            <audio
              autoplay="true"
              style={{ width: 270 }}
              width="270px"
              preload="none"
              src={`${serverHost()}/${playAudio}`}
              controls="controls"
              controlsList="nodownload"
            />
            <br />
            <br />
          </DialogContentText>
        </DialogContent>
        <ThemeProvider theme={theme}>
          <Button
            style={{ margin: "0px 10px 10px 10px" }}
            sx={{ color: "#FFFF" }}
            variant="contained"
            onClick={() => {
              setPlay(false);
            }}
          >
            Fechar
          </Button>
        </ThemeProvider>
      </Dialog>
    </List>
  );
}
const theme = createTheme({
  palette: {
    primary: {
      main: "#A3A3A3",
      color: "white",
    },
  },
});
